import { ENUM_SmartSearchCaseStatus } from '@api-new/common';

export const ENUM_SmartSearchCaseStatusMap = new Map([
  [ENUM_SmartSearchCaseStatus.SMART_SEARCH_CASE_STATUS_LEAD, 'Callback requested'],
  [ENUM_SmartSearchCaseStatus.SMART_SEARCH_CASE_STATUS_PIPELINE, 'Being advised'],
]);
